const NewHireActionTypes = {
  GET_DATA_START: 'GET_DATA_START',
  GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
  GET_DATA_FAILURE: 'GET_DATA_FAILURE',

  GET_DEPARTMENT_TAIL_MAPPING: 'GET_DEPARTMENT_TAIL_MAPPING',
  GET_INVOICE_GROUP_MAPPING: 'GET_INVOICE_GROUP_MAPPING',
  GET_EXPENSE_POLICY_MAPPING: 'GET_EXPENSE_POLICY_MAPPING',

  SET_CURR_DEPARTMENT: 'SET_CURR_DEPARTMENT',
  SET_CURR_POSITION: 'SET_CURR_POSITION',
  SET_FIRST_NAME: 'SET_FIRST_NAME',
  SET_LAST_NAME: 'SET_LAST_NAME',
  SET_LOCAL_DISTROS: 'SET_LOCAL_DISTROS',
  SET_HIRE_DATE: 'SET_HIRE_DATE',
  SET_LOCATION: 'SET_LOCATION',

  SET_AZURE_GROUPS: 'SET_AZURE_GROUPS',
  SET_GOOGLE_GROUPS: 'SET_GOOGLE_GROUPS',

  SET_NOC: 'SET_NOC',
  SET_NAVITAIRE: 'SET_NAVITAIRE',
  SET_UBER: 'SET_UBER',
  SET_LYFT: 'SET_LYFT',

  CLEAR_CURR_DEPARTMENT: 'CLEAR_CURR_DEPARTMENT',
  CLEAR_FIRST_NAME: 'CLEAR_FIRST_NAME',
  CLEAR_LAST_NAME: 'CLEAR_LAST_NAME',
  CLEAR_HIRE_DATE: 'CLEAR_HIRE_DATE',
  CLEAR_CURR_POSITION: 'CLEAR_CURR_POSITION',
  CLEAR_LOCAL_DISTROS: 'CLEAR_LOCAL_DISTROS',
};

export default NewHireActionTypes;
